import { EgretLoadable } from "egret";

const AppChat = EgretLoadable({
  loader: () => import("./AppChat")
});

const adminChatRoutes = [
  {
    path: "/agentChat/*",
    component: AppChat
  }
];

export default adminChatRoutes;
